import { render, staticRenderFns } from "./JQuickTab.vue?vue&type=template&id=6e89f8e6&scoped=true"
import script from "./JQuickTab.vue?vue&type=script&lang=js"
export * from "./JQuickTab.vue?vue&type=script&lang=js"
import style0 from "./JQuickTab.vue?vue&type=style&index=0&id=6e89f8e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e89f8e6",
  null
  
)

export default component.exports